import { HelpRhombusOutlineIcon } from './HelpRhombusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id B08F035A-9304-4D3B-AADD-395971E74294
 * name help-rhombus-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/help-rhombus-outline.svg
 * tags
 */
export const QuestionMarkRhombusOutlineIcon = HelpRhombusOutlineIcon;
export default QuestionMarkRhombusOutlineIcon